import AdminList from './AdminList'

export default AdminList;